export default {
  title: '我的收藏',
  no_collection: '暫無收藏商品',
  reward_points: '{num}倍點數',
  productStockStatus: '庫存緊張',
  disposals: '處分品',
  full_minus: '滿減',
  full_discount_coupon: '滿折券',
  full_coupon_reduction: '滿減券',
  parcel_post_voucher: '運費抵用券',
  replenishment: '補貨中',
  to_end: '頁面底端',
  success: '加入購物車成功!',
  fail: '加入購物車失敗!',
  del_success: '取消成功!',
  bunding: '同捆'
};